export default (params) => ({
  trigger: {
    name: 'breadcrumbs.select_category_in_breadcrumbs',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'vertical_breadcrumbs',
          'horizontal_breadcrumbs',
        ],
      },
    },
    event: {
      name: 'select_navigation',
    },
  },
});
